import type { ThirdPartyConfigsBootstrap } from '../constants/schemas/3p-config';

export const isEligibleFor3PClickIngestion = (
	thirdPartyConfigs: ThirdPartyConfigsBootstrap,
): boolean =>
	Object.keys(thirdPartyConfigs).some(
		(productKey) => thirdPartyConfigs[productKey]?.userNeedsOAuth === false,
	);
